import { Component } from "react";
import { Layout, Modal, Table, Collapse, Space, Spin } from "antd";
import "./App.css";
import foreign from "./foreign.png";
import { ethers } from "ethers";
import { hexZeroPad } from "@ethersproject/bytes";
import stamp from "./mevStamp.png";
const { Panel } = Collapse;
const { Content, Footer } = Layout;

let provider = new ethers.providers.AlchemyProvider(
  "homestead",
  "sqUmRjXqUbiOVDw6ysdWue2oK9f0c6mg"
);

// let provider = new ethers.providers.JsonRpcProvider({url: "https://bsc-dataseed.binance.org/"});

// token0 -> token1 : out
// token0 <- token1 : in

function hash_triplet(triplet) {
  let txn1_bytes = ethers.utils.arrayify(triplet[0].transactionHash);
  let txn2_bytes = ethers.utils.arrayify(triplet[2].transactionHash);
  let identifier = new Uint8Array(txn1_bytes.length + txn2_bytes.length);
  identifier.set(txn1_bytes);
  identifier.set(txn2_bytes, txn1_bytes.length);
  let hash = ethers.utils.keccak256(identifier);
  return hash;
}

function unique(value, index, self) {
  return self.indexOf(value) === index;
}

function merge_approval_swap(approval_list, swap_list, block_infos) {
  var valid_txns = {};
  for (let swap_info of swap_list) {
    valid_txns[swap_info.transactionHash] = swap_info;
  }

  for (let approval_info of approval_list) {
    let approved_addr = approval_info.topics[2];
    // search for all swap events for the approval_info's transaction
    // for any swap events in the txn originating from approved address, we'll consider it as the user's
    if (approval_info.blockHash in block_infos) {
      let swap_logs = block_infos[approval_info.blockHash].filter((v) => {
        /* let myflag = v.transactionHash === approval_info.transactionHash; */
        return (
          v.transactionHash === approval_info.transactionHash &&
          hexZeroPad(v.topics[1], 32) === approved_addr
        );
      });
      for (let swap_log of swap_logs) {
        if (!(swap_log.transactionHash in valid_txns)) {
          valid_txns[swap_log.transactionHash] = swap_log;
        }
      }
    }
  }

  var processed = [];
  for (let swap_info of Object.values(valid_txns)) {
    if (swap_info.blockHash in block_infos) {
      let block_info = block_infos[swap_info.blockHash];
      processed.push([block_info, swap_info]);
    }
  }

  return processed;
}

function sleep(ms) {
  return new Promise((resolve) => setTimeout(resolve, ms));
}

async function prepare_data(block_hashes) {
  let chunk = 100;
  // prepare initial data
  var initial_data = [];
  var count = 0;
  for (let block_hash of block_hashes) {
    let block_swaps_promise = provider.getLogs({
      topics: [
        "0xd78ad95fa46c994b6551d0da85fc275fe613ce37657fb8d5e3d130840159d822",
      ],
      blockHash: block_hash,
    });
    initial_data.push(block_swaps_promise);
    count++;
    if (count % chunk === 0) {
      console.log(count);
      await sleep(1000);
    }
  }

  let block_infos = await Promise.all(initial_data);

  var block_map = {};
  for (let block_info of block_infos) {
    if (block_info.length > 2) {
      block_map[block_info[0].blockHash] = block_info;
    }
  }

  return block_map;
}

function decode_swap_data(swap_info) {
  let swap_data = ethers.utils.arrayify(swap_info.data);
  let amount0_in = ethers.BigNumber.from(swap_data.slice(0, 32));
  let amount1_in = ethers.BigNumber.from(swap_data.slice(32, 64));
  let amount0_out = ethers.BigNumber.from(swap_data.slice(64, 96));
  let amount1_out = ethers.BigNumber.from(swap_data.slice(96, 128));
  return [amount0_in, amount1_in, amount0_out, amount1_out];
}

function decode_swap(swap_info) {
  let swap_data = decode_swap_data(swap_info);
  let address = swap_info.address;
  let direction = swap_data[0].eq(0) ? 0 : 1;
  let from = swap_info.topics[1];
  let to = swap_info.topics[2];
  // we'll just include a copy of the swap log into the decoded form
  // not sure about javascript but swap_info should be a reference
  return [address, [from, to], direction, swap_info];
}

function quick_filter(block_info) {
  let [swap_block, user_swap] = block_info;
  // find all instances of the transaction hash
  let swap_instances = swap_block.filter(
    (log_info) => log_info.transactionHash === user_swap.transactionHash
  );
  let decoded_block = swap_block.map(decode_swap);

  var results = {};
  for (let victim_log of swap_instances) {
    let index = swap_block.findIndex(
      (log_info) => log_info.logIndex === victim_log.logIndex
    );

    let before_slice = decoded_block.slice(0, index);
    let after_slice = decoded_block.slice(index + 1);

    if (before_slice.length === 0 || after_slice.length === 0) {
      continue;
    }

    let victim = decoded_block[index];

    let before = before_slice.filter(
      (v) => v[0] === victim[0] && v[2] === victim[2]
    );
    let after = after_slice.filter(
      (v) => v[0] === victim[0] && v[2] !== victim[2]
    );

    if (before.length === 0 || after.length === 0) {
      continue;
    }

    // for each pivot point, calculate the mev...
    // find if a corresponding mev realization is in the block
    var mevs = [];
    for (let pivot of before) {
      let mev_realizations = after.filter((v) => v[1][0] === pivot[1][1]);
      for (let mev_realization of mev_realizations) {
        let potential_attack = [pivot[3], victim[3], mev_realization[3]];
        let mev = calculate_mev(potential_attack);
        // currently we don't consider sandwich attacks that has a negative
        // tokens on 1 side but have an overall gain
        if (mev[0].gte(0) && mev[1].gte(0)) {
          if (mev[0].gt(0) || mev[1].gt(0)) {
            mevs.push([potential_attack, mev, victim[0]]);
          }
        }
      }
    }
    if (mevs.length !== 0) {
      // TODO: current assumption is 1 of the values is 0
      mevs.sort(compare_mev);
      let mev = mevs[0];
      let attack_hash = hash_triplet(mev[0]);
      results[attack_hash] = mev;
      continue;
    }
  }
  let unique_results = Object.entries(results).map((v) => v[1]);
  return unique_results;
}

function compare_mev(v1, v2) {
  let mev1 = v1[1];
  let mev2 = v2[1];
  if (mev1[0].gt(0)) {
    return mev2[0].gt(mev1[0]);
  } else if (mev1[1].gt(0)) {
    return mev2[1].gt(mev1[1]);
  } else {
    return 0;
  }
}

function calculate_mev(triplet) {
  let [a1, , a2] = triplet;
  let d1 = decode_swap_data(a1);
  let d2 = decode_swap_data(a2);
  let t1_in = d1[0].add(d2[0]);
  let t2_in = d1[1].add(d2[1]);
  let t1_out = d1[2].add(d2[2]);
  let t2_out = d1[3].add(d2[3]);
  let t1_gain = t1_out.sub(t1_in);
  let t2_gain = t2_out.sub(t2_in);
  return [t1_gain, t2_gain];
}

async function main(userAddress) {
  let user_address = userAddress;

  let swap_filter = {
    fromBlock: 0,
    toBlock: "latest",
    topics: [
      "0xd78ad95fa46c994b6551d0da85fc275fe613ce37657fb8d5e3d130840159d822",
      null,
      hexZeroPad(user_address, 32),
    ],
  };
  let approval_filter = {
    fromBlock: 0,
    toBlock: "latest",
    topics: [
      "0x8c5be1e5ebec7d5bd14f71427d1e84f3dd0314c0f7b2291e5b200ac8c7c3b925",
      hexZeroPad(user_address, 32),
    ],
  };
  let [user_swaps, user_approvals] = await Promise.all([
    provider.getLogs(swap_filter),
    provider.getLogs(approval_filter),
  ]);

  // merge block hashes...
  let block_hashes = [user_swaps, user_approvals]
    .flat()
    .map((v) => v.blockHash)
    .filter(unique);

  let block_infos = await prepare_data(block_hashes);
  let processed_block_infos = merge_approval_swap(
    user_approvals,
    user_swaps,
    block_infos
  );
  let results = processed_block_infos.map(quick_filter).flat();
  return results;
}

async function get_token_pairs(attacks) {
  let mainContractABI = [
    //get token0 address
    "function token0() external view returns (address)",
    //get token1 address
    "function token1() external view returns (address)",
  ];

  // each attack is of the form
  // [triplet, mev, pair address]
  let unique_pair_addrs = attacks.map((v) => v[2]).filter(unique);
  let token_addrs_promises = unique_pair_addrs.map((v) => {
    let pair_contract = new ethers.Contract(v, mainContractABI, provider);
    return Promise.all([pair_contract.token0(), pair_contract.token1()]);
  });
  // we get all the token addresses...
  let token_addrs = await Promise.all(token_addrs_promises);

  var token_pairs = {};
  for (var x = 0; x < token_addrs.length; x++) {
    token_pairs[unique_pair_addrs[x]] = token_addrs[x];
  }
  return token_pairs;
}

async function get_token_infos(token_pairs) {
  var x;
  let tokenContractABI = [
    "function decimals() public view returns (uint8)",
    "function symbol() public view returns (string memory)",
    // alternate method
    "function getSymbol() external view returns(string memory)",
  ];

  let token_addrs = Object.values(token_pairs).flat().filter(unique);

  let token_decimal_promises = token_addrs.map((addr) => {
    let token_contract = new ethers.Contract(addr, tokenContractABI, provider);
    return token_contract.decimals();
  });

  // decimals are optional too
  let token_decimals = (await Promise.allSettled(token_decimal_promises)).map(
    (v) => {
      if (v.status === "fulfilled") {
        return v.value;
      }
      return 18;
    }
  );

  let token_name_promises = token_addrs.map((addr) => {
    let token_contract = new ethers.Contract(addr, tokenContractABI, provider);
    return token_contract.symbol();
  });

  // since .symbol() is optional...
  let token_names = await Promise.allSettled(token_name_promises);

  var token_retry = [];
  var token_map = {};

  for (x = 0; x < token_addrs.length; x++) {
    if (token_names[x].status === "rejected") {
      token_retry.push(token_addrs[x]);
      token_map[token_addrs[x]] = ["deadbeef", token_decimals[x]];
    } else if (token_names[x].status === "fulfilled") {
      token_map[token_addrs[x]] = [token_names[x].value, token_decimals[x]];
    } else {
      // not supposed to be here
      throw new Error("token retry promises have weird return value");
    }
  }

  // we'll run a second round with the alternate call
  let retry_promises = token_retry.map((addr) => {
    let token_contract = new ethers.Contract(addr, tokenContractABI, provider);
    return token_contract.getSymbol();
  });

  // again, we don't know if there is getSymbol()...
  let retry_token_names = await Promise.allSettled(retry_promises);

  var unknown_token_count = 1;

  for (x = 0; x < token_retry.length; x++) {
    if (retry_token_names[x].status === "rejected") {
      // we'll put an unknown token here
      token_map[token_retry[x]][0] = "UnknownToken" + unknown_token_count++;
    } else if (token_names[x].status === "fulfilled") {
      token_map[token_retry[x]][0] = retry_token_names[x].value;
    } else {
      // not supposed to be here
      throw new Error("token retry promises have weird return value");
    }
  }

  // we're done... now we have all the token_names....

  return token_map;
}

async function get_token_prices(token_map) {
  let token_addrs = Object.keys(token_map);
  let query_string = token_addrs.join("%2C");
  let price_map = await fetch(
    "https://api.coingecko.com/api/v3/simple/token_price/ethereum?contract_addresses=" +
      query_string +
      "&vs_currencies=usd"
  ).then((response) => response.json());

  // just copy pasta here... :)
  let ethPrice = await fetch(
    "https://api.coingecko.com/api/v3/simple/price?ids=weth&vs_currencies=usd"
  )
    .then((response) => response.json())
    .then((data) => {
      return data["weth"]["usd"];
    })
    .catch((err) => {
      console.log(err);
      return 0;
    });
  price_map["eth"] = ethPrice;

  return price_map;
}

async function get_victim_infos(attacks) {
  // let txn_promises = attack.map((txn) => {
  //   let receipt = provider.getTransactionReceipt(attack[x].transactionHash);
  //   let txn = provider.getTransaction(attack[x].transactionHash);
  //   return Promise.all([receipt, txn]);
  // })
  // let txns = await txn_promises;
  // let txn_gas_costs_eth = txns.map(([receipt, txn]) => {
  //   return receipt.gasUsed * txn.gasPrice;
  // });

  let victim_logs = attacks.map((v) => v[0][1]);
  let victim_txn_promises = victim_logs.map((victim_log) => {
    let receipt = provider.getTransactionReceipt(victim_log.transactionHash);
    let txn = provider.getTransaction(victim_log.transactionHash);
    return Promise.all([receipt, txn]);
  });

  let victim_txns = await Promise.all(victim_txn_promises);
  let victim_infos = victim_txns.map(([receipt, txn]) => {
    let gas_cost_raw_eth = ethers.BigNumber.from(receipt.gasUsed).mul(
      txn.gasPrice
    );
    let txn_gas_cost_eth = ethers.utils.formatEther(gas_cost_raw_eth);
    let block_number = txn.blockNumber;
    let block_data = provider.getBlock(block_number);
    let timestamp = block_data.then((v) => v.timestamp);
    return Promise.all([timestamp, txn_gas_cost_eth]);
  });
  return await Promise.all(victim_infos);
}

function get_mev_usd(attack, token_pairs, token_infos, token_prices) {
  let mev = attack[1];
  let contract_addr = attack[2];
  var token_gains_usd = [];
  for (var x = 0; x < 2; x++) {
    let token_addr = token_pairs[contract_addr][x];
    let token_decimals = token_infos[token_addr][1];
    let token_price =
      token_addr.toLowerCase(0) in token_prices
        ? parseFloat(token_prices[token_addr.toLowerCase()].usd)
        : 0.0;
    let norm_tokens = parseFloat(mev[x]) / parseFloat("1e" + token_decimals);
    let token_gain_usd = norm_tokens * token_price;
    token_gains_usd.push([norm_tokens, token_gain_usd]);
  }
  return token_gains_usd;
}

async function gen_main_table(attacks) {
  let token_pairs = await get_token_pairs(attacks);
  let token_infos = await get_token_infos(token_pairs);
  let token_prices = await get_token_prices(token_infos);
  let victim_infos = await get_victim_infos(attacks);

  let table = attacks.map((attack, index) => {
    let [triple, , pair_addr] = attack;
    console.log(triple[0]);
    let [t0_addr, t1_addr] = token_pairs[pair_addr];
    let mev_gains = get_mev_usd(attack, token_pairs, token_infos, token_prices);
    let mev_token = mev_gains.map((v) => v[0]);
    let mev_usd = mev_gains.map((v) => v[1]);
    let mev_symbol =
      mev_usd[0] > mev_usd[1]
        ? token_infos[t0_addr][0]
        : token_infos[t1_addr][0];
    let mev_total_usd = mev_usd.reduce((acc, v) => acc + v, 0);
    let mev_total_token = mev_token.reduce((acc, v) => acc + v, 0);
    let [timestamp, txn_gas_cost_eth] = victim_infos[index];
    let txn_gas_cost_usd = txn_gas_cost_eth * token_prices["eth"];
    let txn_fee = txn_gas_cost_usd + mev_total_usd;

    let trading_pair_string =
      token_infos[t0_addr][0] + "-" + token_infos[t1_addr][0];
    let mev_string = mev_total_token + " " + mev_symbol;
    let gas_string = txn_gas_cost_eth + " ETH";
    let txn_fee_string = txn_fee.toFixed(2) + " USD";

    console.log(timestamp);
    let datetime_string = new Date(timestamp * 1000).toLocaleString();

    return {
      item: "Sandwich Attack",
      tradingPair: trading_pair_string,
      mev: mev_string,
      mevSymbol: mev_symbol,
      gas: gas_string,
      txnFee: txn_fee_string,
      txnFeeRaw: txn_fee,
      mevUSD: mev_total_usd,
      gasPaidUSD: txn_gas_cost_usd,
      key: index,
      triplet: [
        {
          timestamp: datetime_string,
          role: "Attacker",
          from: triple[0].transactionHash,
          tradingPair: trading_pair_string,
          mev: "-",
          hash: triple[0].transactionHash,
        },
        {
          timestamp: datetime_string,
          role: "Victim",
          from: triple[1].transactionHash,
          tradingPair: trading_pair_string,
          mev: "-",
          hash: triple[1].transactionHash,
        },
        {
          timestamp: datetime_string,
          role: "Attacker",
          from: triple[2].transactionHash,
          tradingPair: trading_pair_string,
          mev: mev_string,
          hash: triple[2].transactionHash,
        },
      ],
    };
  });
  return table;
}

class App extends Component {
  state = {
    accounts: null,
    status: "noMetamask",
    attacked: null,
    mevTotal: null,
    avgMev: null,
    mevSymbol: "",
    gasCount: null,
    gasTotal: null,
    gasAvg: null,
    percent: 0,
    printingStatus: "Running MEV.Tax...",
    isModalVisible: false,
    setIsModalVisible: false,
    sandwichedTxFull: [],
    walletText: "",
    network: "",
    mainTableData: [],
    detailTableData: [],
    tableText: "",
    isDesktop: false,
  };

  callback = (key) => {};

  showModal = (rowIndex) => {
    let selectedData = this.state.mainTableData[rowIndex].triplet;
    this.setState({ isModalVisible: true, detailTableData: selectedData });
  };

  handleOk = () => {
    this.setState({ isModalVisible: false });
  };

  componentDidMount = async () => {
    this.updateIsDesktop();
    window.addEventListener("resize", this.updateIsDesktop);

    let search = window.location.search;
    let params = new URLSearchParams(search);
    let queryAddress = params.get("address");

    const currentNetwork = await provider.getNetwork().then((res) => {
      switch (res.chainId) {
        case 1:
          return "Ethereum Mainnet";
        case 3:
          return "Ropsten Testnet";
        case 4:
          return "Rinkeby Testnet";
        case 5:
          return "Goerli Testnet";
        default:
          return "Unknown/private network.";
      }
    });

    if (queryAddress === null && !window.ethereum) {
      return;
    } else if (queryAddress !== null) {
      this.setState({
        accounts: queryAddress,
        status: "printing",
        percent: 10,
        network: currentNetwork,
      });
    } else {
      if (window.ethereum) {
        provider = new ethers.providers.Web3Provider(window.ethereum, "any");
        // Prompt user for account connections
        await provider.send("eth_requestAccounts", []);
        const signer = provider.getSigner();
        const account = await signer.getAddress();
        this.setState({
          status: "printing",
          walletText: "Connected address :",
          accounts: account,
          percent: 10,
          network: currentNetwork,
        });
      }
    }

    //call mev.js function

    let attacks = await main(this.state.accounts).then((res) => res);

    //cached attacks for testing
    /* let attacks = [
      [
        [
          {
            address: "0x1721C6cA0Ee29f3ABE10988647cEEE974776DcaD",
            blockHash:
              "0x23c3722c6a343540544ac5a7a2c7a990e4a30badc5960bcc6940e303fc23fb87",
            blockNumber: 12366582,
            data: "0x0000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000001c226cc1104d4b3270000000000000000000000000000000000000000017fe05b638c2b24dfccc6a60000000000000000000000000000000000000000000000000000000000000000",
            logIndex: 3,
            removed: false,
            topics: [
              "0xd78ad95fa46c994b6551d0da85fc275fe613ce37657fb8d5e3d130840159d822",
              "0x000000000000000000000000a3b0e79935815730d942a444a84d4bd14a339553",
              "0x000000000000000000000000a3b0e79935815730d942a444a84d4bd14a339553",
            ],
            transactionHash:
              "0x6b120d19effb06c2a4bfc6a84a88c118670d0bdd23cacad377276bec818e9983",
            transactionIndex: 0,
          },
          {
            address: "0x1721C6cA0Ee29f3ABE10988647cEEE974776DcaD",
            blockHash:
              "0x23c3722c6a343540544ac5a7a2c7a990e4a30badc5960bcc6940e303fc23fb87",
            blockNumber: 12366582,
            data: "0x0000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000003c372a18883411000000000000000000000000000000000000000000000a9823f1e2108fce90e00000000000000000000000000000000000000000000000000000000000000000",
            logIndex: 298,
            removed: false,
            topics: [
              "0xd78ad95fa46c994b6551d0da85fc275fe613ce37657fb8d5e3d130840159d822",
              "0x0000000000000000000000007a250d5630b4cf539739df2c5dacb4c659f2488d",
              "0x000000000000000000000000ba29bf8046d46d687dc00f09caddb0c83540caeb",
            ],
            transactionHash:
              "0x9295adcfb49cdd43766e5608b46a02c1abf2220d24748ed8017e587803a3a003",
            transactionIndex: 1,
          },
          {
            address: "0x1721C6cA0Ee29f3ABE10988647cEEE974776DcaD",
            blockHash:
              "0x23c3722c6a343540544ac5a7a2c7a990e4a30badc5960bcc6940e303fc23fb87",
            blockNumber: 12366582,
            data: "0x0000000000000000000000000000000000000000017fe05b638c2b24dfccc6a600000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000001cecafbbaa2fc9f38",
            logIndex: 302,
            removed: false,
            topics: [
              "0xd78ad95fa46c994b6551d0da85fc275fe613ce37657fb8d5e3d130840159d822",
              "0x000000000000000000000000a3b0e79935815730d942a444a84d4bd14a339553",
              "0x000000000000000000000000a3b0e79935815730d942a444a84d4bd14a339553",
            ],
            transactionHash:
              "0x402e9b2c160ac70d5e700c359efd3ab12756e8749a61d2ea221b30714dc217a3",
            transactionIndex: 2,
          },
        ],
        [
          { _hex: "0x00", _isBigNumber: true },
          { _hex: "0x0ca42fa99e27ec11", _isBigNumber: true },
        ],
        "0x1721C6cA0Ee29f3ABE10988647cEEE974776DcaD",
      ],
      [
        [
          {
            address: "0x1721C6cA0Ee29f3ABE10988647cEEE974776DcaD",
            blockHash:
              "0x23c3722c6a343540544ac5a7a2c7a990e4a30badc5960bcc6940e303fc23fb87",
            blockNumber: 12366582,
            data: "0x0000000000000000000000000000000000000000017fe05b638c2b24dfccc6a600000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000001cecafbbaa2fc9f38",
            logIndex: 302,
            removed: false,
            topics: [
              "0xd78ad95fa46c994b6551d0da85fc275fe613ce37657fb8d5e3d130840159d822",
              "0x000000000000000000000000a3b0e79935815730d942a444a84d4bd14a339553",
              "0x000000000000000000000000a3b0e79935815730d942a444a84d4bd14a339553",
            ],
            transactionHash:
              "0x402e9b2c160ac70d5e700c359efd3ab12756e8749a61d2ea221b30714dc217a3",
            transactionIndex: 2,
          },
          {
            address: "0xDA3A20aaD0C34fA742BD9813d45Bbf67c787aE0b",
            blockHash:
              "0x33708697e60d4659047ec47899bef5f15bb4b60d5a36002b098b1ba93d91c107",
            blockNumber: 12420942,
            data: "0x000000000000000000000000000000000000000183bdac6ae9bc1c8cc000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000007ad37f5efa257b784",
            logIndex: 35,
            removed: false,
            topics: [
              "0xd78ad95fa46c994b6551d0da85fc275fe613ce37657fb8d5e3d130840159d822",
              "0x0000000000000000000000007a250d5630b4cf539739df2c5dacb4c659f2488d",
              "0x0000000000000000000000007a250d5630b4cf539739df2c5dacb4c659f2488d",
            ],
            transactionHash:
              "0x78481f74355950ed905a43b39cec3f89812edfb0969f0b67c1986a6c24bc129c",
            transactionIndex: 6,
          },
          {
            address: "0xDA3A20aaD0C34fA742BD9813d45Bbf67c787aE0b",
            blockHash:
              "0x33708697e60d4659047ec47899bef5f15bb4b60d5a36002b098b1ba93d91c107",
            blockNumber: 12420942,
            data: "0x000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000051112465cecc5d4800000000000000000000000000000000000000001249ac3df474e69c6291377c0000000000000000000000000000000000000000000000000000000000000000",
            logIndex: 40,
            removed: false,
            topics: [
              "0xd78ad95fa46c994b6551d0da85fc275fe613ce37657fb8d5e3d130840159d822",
              "0x0000000000000000000000003dad8cf200799f82fd8eb68f608220d8f3ebf8de",
              "0x0000000000000000000000003dad8cf200799f82fd8eb68f608220d8f3ebf8de",
            ],
            transactionHash:
              "0xe97424d8ce41431f6cb307825a5ee0c201f0b15330a3348bda4b835ee946d2b4",
            transactionIndex: 7,
          },
        ],
        [
          { _hex: "0x00", _isBigNumber: true },
          { _hex: "0x1affd6d8532b22b7", _isBigNumber: true },
        ],
        "0xDA3A20aaD0C34fA742BD9813d45Bbf67c787aE0b",
      ],
      [
        [
          {
            address: "0xDA3A20aaD0C34fA742BD9813d45Bbf67c787aE0b",
            blockHash:
              "0xff89f80b596873a586b23e2ffac6116cda6a1b15aca057b88069cbdb7d1920da",
            blockNumber: 12420947,
            data: "0x0000000000000000000000000000000000000000124a00cc2460341e9a7a34f1000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000006600720edb1effff",
            logIndex: 45,
            removed: false,
            topics: [
              "0xd78ad95fa46c994b6551d0da85fc275fe613ce37657fb8d5e3d130840159d822",
              "0x0000000000000000000000003dad8cf200799f82fd8eb68f608220d8f3ebf8de",
              "0x0000000000000000000000003dad8cf200799f82fd8eb68f608220d8f3ebf8de",
            ],
            transactionHash:
              "0xdcd4cb7d6cf659e68e42fc674b2adbe6ef60921d12af1c2ecc79b723fbd062d0",
            transactionIndex: 13,
          },
          {
            address: "0xDA3A20aaD0C34fA742BD9813d45Bbf67c787aE0b",
            blockHash:
              "0xff89f80b596873a586b23e2ffac6116cda6a1b15aca057b88069cbdb7d1920da",
            blockNumber: 12420947,
            data: "0x000000000000000000000000000000000000000122ce41502f4d15699000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000005a4c83baaf8ddeb63",
            logIndex: 51,
            removed: false,
            topics: [
              "0xd78ad95fa46c994b6551d0da85fc275fe613ce37657fb8d5e3d130840159d822",
              "0x0000000000000000000000007a250d5630b4cf539739df2c5dacb4c659f2488d",
              "0x0000000000000000000000007a250d5630b4cf539739df2c5dacb4c659f2488d",
            ],
            transactionHash:
              "0x472b914a37f1be38f466499789d0b01cca7de4df5103095df5b36f678a1def36",
            transactionIndex: 14,
          },
          {
            address: "0xDA3A20aaD0C34fA742BD9813d45Bbf67c787aE0b",
            blockHash:
              "0xff89f80b596873a586b23e2ffac6116cda6a1b15aca057b88069cbdb7d1920da",
            blockNumber: 12420947,
            data: "0x0000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000528811ec58226cf40000000000000000000000000000000000000000124a00cc2460341e9a7a34f10000000000000000000000000000000000000000000000000000000000000000",
            logIndex: 56,
            removed: false,
            topics: [
              "0xd78ad95fa46c994b6551d0da85fc275fe613ce37657fb8d5e3d130840159d822",
              "0x0000000000000000000000003dad8cf200799f82fd8eb68f608220d8f3ebf8de",
              "0x0000000000000000000000003dad8cf200799f82fd8eb68f608220d8f3ebf8de",
            ],
            transactionHash:
              "0xe186af2286ef074868c2e08220c784dc3b1f36577ea6ef1a47d98ce003530331",
            transactionIndex: 15,
          },
        ],
        [
          { _hex: "0x00", _isBigNumber: true },
          { _hex: "0x1378602282fc930b", _isBigNumber: true },
        ],
        "0xDA3A20aaD0C34fA742BD9813d45Bbf67c787aE0b",
      ],
    ]; */

    console.log(attacks);

    var table_text = "";
    if (attacks.length === 0) {
      table_text = "Phew! No sandwich attacks were found on your address.";
    }

    let table = await gen_main_table(attacks);

    //sum all gas and txfee;
    let mevTotal = table.reduce(function (sum, current) {
      return sum + current.txnFeeRaw;
    }, 0);

    let gasTotal = table.reduce(function (sum, current) {
      return sum + current.gasPaidUSD;
    }, 0);

    this.setState({
      mainTableData: table,
      status: "done",
      tableText: table_text,
      mevTotal: mevTotal,
      gasTotal: gasTotal,
    });

    // listen for account change
    try {
      await window.ethereum.on("accountsChanged", async (account) => {
        this.setState({
          status: "printing",
          walletText: "Connected address :",
          accounts: account[0],
          percent: 10,
        });
        await main(this.state.accounts).then(async (result) => {
          if (result.length === 0) {
            this.setState({
              status: "done",
              tableText:
                "Phew! No sandwich attacks were found on your address.",
            });
          } else {
          }
        });
      });
    } catch {
      console.log("Error fetching table.");
    }
  };

  componentWillUnmount = () => {
    window.removeEventListener("resize", this.updateIsDesktop);
  };

  updateIsDesktop = () => {
    this.setState({ isDesktop: window.innerWidth > 800 });
  };

  renderTable = () => {
    if (this.state.status === "printing") {
      return (
        <div>
          <h1>{this.state.printingStatus}</h1>
          <Space>
            <Spin size="large" />
          </Space>
        </div>
      );
    } else if (this.state.status === "done") {
      const mainColumns = [
        {
          title: "Item",
          dataIndex: "item",
          key: "index",
          render: (text) => <span>{text}</span>,
        },
        {
          title: "Pair",
          dataIndex: "tradingPair",
          key: "index",
        },
        {
          title: "MEV Extracted",
          dataIndex: "mev",
          key: "index",
        },
        {
          title: "Gas Paid",
          dataIndex: "gas",
          key: "index",
        },
        {
          title: "Txn Cost",
          dataIndex: "txnFee",
          key: "index",
        },
      ];
      const detailsColumns = [
        {
          title: "Local Time",
          dataIndex: "timestamp",
          key: "index",
        },
        {
          title: "Role",
          dataIndex: "role",
          key: "index",
        },
        {
          title: "Transaction Address",
          dataIndex: "from",
          key: "index",
        },
        {
          title: "Trading Pair",
          dataIndex: "tradingPair",
          key: "index",
        },
        {
          title: "Extracted Amount",
          dataIndex: "mev",
          key: "index",
        },
        {
          title: "Link",
          dataIndex: "hash",
          key: "index",
          render: (text) => (
            <a
              href={"https://etherscan.io/tx/" + text}
              target="_blank"
              rel="noreferrer"
            >
              <img src={foreign} alt="foreignIcon" style={{ width: "10px" }} />
            </a>
          ),
        },
      ];

      return (
        <div>
          <h1 className="mevTitle">MEV Tax Receipt</h1>{" "}
          <img src={stamp} alt="mevStamp" className="stampImage" />
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <div className="detailsAboveTable">
              <div style={{ width: "90%", textAlign: "left" }}>
                <h3 className="receiptText">Network name : </h3>
                <span className="receiptTextSpan">{this.state.network}</span>
                <br />
                <br />
                <h3 className="receiptText">User address : </h3>
                <span className="receiptTextSpan">
                  {this.truncate(this.state.accounts)}
                </span>
              </div>

              <div className="detailsAboveTableRight">
                <h3 className="receiptText">Total Gas Paid :</h3>
                <span className="receiptTextSpan">
                  {" "}
                  {this.state.gasTotal.toFixed(2)} USD
                </span>
                <br />
                <br />
                <h3 className="receiptText">Total MEV Extracted :</h3>
                <span className="receiptTextSpan">
                  {" "}
                  {this.state.mevTotal.toFixed(2)} USD
                </span>
              </div>
            </div>

            {this.state.isDesktop ? (
              <Table
                dataSource={this.state.mainTableData}
                columns={mainColumns}
                pagination={false}
                style={{
                  marginTop: "30px",
                  marginBottom: "30px",
                  width: "90%",
                }}
                onRow={(record, rowIndex) => {
                  return {
                    onClick: (event) => {
                      this.showModal(rowIndex);
                    },
                  };
                }}
              />
            ) : (
              <table style={{ width: "100%", marginTop: "30px" }}>
                <thead className="tableHeader">
                  <tr>
                    <th style={{ width: "25%" }}>Parameters</th>
                    <th>Values</th>
                  </tr>
                </thead>
                <tbody>
                  {this.state.mainTableData.map((item) => {
                    return (
                      <tr className="tableBottomInternal">
                        <td
                          colSpan="2"
                          style={{ textAlign: "right", fontSize: "0.8rem" }}
                        >
                          <table
                            style={{ width: "100%" }}
                            cellspacing="0"
                            cellpadding="0"
                          >
                            <tbody>
                              <tr>
                                <td className="tableInternalTD">
                                  <span>Item</span>
                                </td>
                                <td className="tableInternalTDtoLeft">
                                  {item.item}
                                </td>
                              </tr>
                              <tr>
                                <td className="tableInternalTD">Pair</td>
                                <td className="tableInternalTDtoLeft">
                                  {item.tradingPair}
                                </td>
                              </tr>
                              <tr>
                                <td className="tableInternalTD">MEV</td>
                                <td className="tableInternalTDtoLeft">
                                  {item.mev.substring(0, 6) +
                                    " " +
                                    item.mevSymbol}
                                </td>
                              </tr>
                              <tr>
                                <td className="tableInternalTD">Gas Paid</td>
                                <td className="tableInternalTDtoLeft">
                                  {item.gas.substring(0, 6) + " ETH"}
                                </td>
                              </tr>
                              <tr>
                                <td className="tableInternalTD">Txn Cost</td>
                                <td className="tableInternalTDtoLeft">
                                  {item.txnFee}
                                </td>
                              </tr>
                              <tr>
                                <td className="tableInternalTD">Txn Details</td>
                                <td className="tableInternalTDtoLeft">
                                  <span
                                    className="viewDetailsText"
                                    onClick={() =>
                                      this.showModal(
                                        this.state.mainTableData.indexOf(item)
                                      )
                                    }
                                  >
                                    View Details
                                  </span>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            )}
          </div>
          <h1 style={{ marginTop: "50px" }}>{this.state.tableText}</h1>
          <Modal
            title="Transaction details"
            visible={this.state.isModalVisible}
            onOk={this.handleOk}
            cancelButtonProps={{ style: { display: "none" } }}
            width={1200}
          >
            {this.state.isDesktop ? (
              <Table
                dataSource={this.state.detailTableData}
                columns={detailsColumns}
                pagination={false}
              />
            ) : (
              <table style={{ width: "100%" }}>
                <thead className="tableHeader">
                  <tr>
                    <th style={{ width: "25%" }}>Parameters</th>
                    <th>Values</th>
                  </tr>
                </thead>
                <tbody>
                  {this.state.detailTableData.map((item) => {
                    return (
                      <tr className="tableBottomInternal">
                        <td
                          colSpan="2"
                          style={{ textAlign: "right", fontSize: "0.8rem" }}
                        >
                          <table
                            style={{ width: "100%" }}
                            cellspacing="0"
                            cellpadding="0"
                          >
                            <tbody>
                              <tr>
                                <td className="tableInternalTD">
                                  <span>Time</span>
                                </td>
                                <td className="tableInternalTDtoLeft">
                                  {item.timestamp}
                                </td>
                              </tr>
                              <tr>
                                <td className="tableInternalTD">Role</td>
                                <td className="tableInternalTDtoLeft">
                                  {item.role}{" "}
                                </td>
                              </tr>
                              <tr>
                                <td className="tableInternalTD">Txn Address</td>
                                <td className="tableInternalTDtoLeft">
                                  {this.truncate(item.from)}{" "}
                                  <a
                                    href={
                                      "https://etherscan.io/tx/" + item.from
                                    }
                                    target="_blank"
                                    rel="noreferrer"
                                  >
                                    <img
                                      src={foreign}
                                      alt="foreignIcon"
                                      style={{ width: "10px" }}
                                    />
                                  </a>
                                </td>
                              </tr>
                              <tr>
                                <td className="tableInternalTD">
                                  Trading Pair
                                </td>
                                <td className="tableInternalTDtoLeft">
                                  {item.tradingPair}
                                </td>
                              </tr>
                              <tr>
                                <td className="tableInternalTD">Extract Amt</td>
                                <td className="tableInternalTDtoLeft">
                                  {item.mev}
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </td>
                        {/* <td style={{ textAlign: "right", fontSize: "0.8rem" }}>
                          <span>Time</span>
                          <br />
                          <span>Role</span>
                          <br />
                          <span>Txn Address</span>
                          <br />
                          <span>Trading Pair</span>
                          <br />
                          <span>Extract Amt</span>
                          <br />
                        </td>
                        <td style={{ fontSize: "0.8rem" }}>
                          <span>{item.timestamp}</span>
                          <br />
                          <span>{item.role}</span>
                          <br />
                          <span>
                            {this.truncate(item.from)}{" "}
                            <a
                              href={"https://etherscan.io/tx/" + item.from}
                              target="_blank"
                              rel="noreferrer"
                            >
                              <img
                                src={foreign}
                                alt="foreignIcon"
                                style={{ width: "10px" }}
                              />
                            </a>
                          </span>
                          <br />
                          <span>{item.tradingPair}</span>
                          <br />
                          <span>{item.mev}</span>
                          <br />
                        </td> */}
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            )}
          </Modal>
        </div>
      );
    } else if (this.state.status === "never") {
      return (
        <div>
          <h1>Oops! No transactions with Uniswap V2 found.</h1>
        </div>
      );
    } else if (this.state.status === "none") {
      return (
        <div>
          <h1>Good news, you have not been MEV taxed!</h1>
          <h1>
            This means that your transactions have not been attacked to date.
          </h1>
        </div>
      );
    } else if (this.state.status === "noMetamask") {
      return (
        <div>
          <h1>Welcome to MEV.Tax!</h1>
          <h1>Please install or connect to Metamask to continue.</h1>
        </div>
      );
    }
  };

  truncate = (fullStr) => {
    let separator = "...";

    var frontChars = 6;
    var backChars = 4;

    return (
      fullStr.substr(0, frontChars) +
      separator +
      fullStr.substr(fullStr.length - backChars)
    );
  };

  render() {
    const disclaimer = (
      <div
        style={{ textAlign: "left", marginTop: "20px", paddingLeft: "40px" }}
      >
        <p>
          MEV.Tax is a community project initiated by{" "}
          <a
            href="https://ata.network/"
            target="_blank"
            style={{ color: "#d77720" }}
            rel="noreferrer"
          >
            Automata Network
          </a>
          , and all information collected via the website MEV.Tax will not be
          stored or distributed for any kind of uses other than the services
          provided by MEV.Tax.
        </p>
        <p>
          If you are interested in contributing to MEV.Tax, please join our{" "}
          <a
            href="https://discord.gg/Us8cxTVRxG"
            target="_blank"
            style={{ color: "#d77720" }}
            rel="noreferrer"
          >
            Discord
          </a>
          .
        </p>
      </div>
    );
    const content = (
      <div style={{ textAlign: "left" }}>
        <ol>
          <li className="faqTitle">What is MEV.Tax?</li>
          <p>
            MEV.Tax is a free tool developed by the
            <a
              href="https://www.ata.network/"
              target="_blank"
              style={{ color: "#d77720" }}
              rel="noreferrer"
            >
              {" "}
              Automata Network
            </a>{" "}
            team to help users uncover the
            <a
              href="https://research.paradigm.xyz/MEV"
              target="_blank"
              style={{ color: "#d77720" }}
              rel="noreferrer"
            >
              {" "}
              'invisible tax'
            </a>{" "}
            when trading on a DEX.
          </p>
          <li className="faqTitle">What is MEV?</li>
          <p>
            MEV stands for 'Miner Extracted Value' and we see it as a hidden
            'tax' that a user unknowingly pays for as a result of an attacker's
            actions.
          </p>

          <li className="faqTitle">How is MEV calculated?</li>
          <p>
            The current version of MEV.Tax runs on the following assumptions:
          </p>
          <ul>
            <li>
              Only intra-block sandwich attacks are identified, i.e., the prior
              and posterior transactions have to be within the same block.
            </li>
            <li>
              Sandwich attacks are assumed to be non-lossy, that is, we do not
              consider attacks that have positive MEV but a loss in one of the
              tokens.
            </li>
          </ul>

          <li className="faqTitle">
            Can I get the MEV Tax Receipt for a specific address?
          </li>
          <p style={{ marginBottom: "0px" }}>
            Sure! Just update the url with an address query like this example
            below:
          </p>
          <em>
            <a
              href="https://mev.tax/?address=0xAb5801a7D398351b8bE11C439e05C5B3259aeC9B"
              target="_blank"
              style={{ color: "#d77720" }}
              rel="noreferrer"
            >
              https://mev.tax/?address=0xAb5801a7D398351b8bE11C439e05C5B3259aeC9B
            </a>
          </em>

          <li className="faqTitle">Want to learn more about MEV?</li>
          <p style={{ marginTop: "14px" }}>
            Check out Automata Network's MEV Wiki{" "}
            <a
              href="https://docs.ata.network/mev/introduction/"
              target="_blank"
              style={{ color: "#d77720" }}
              rel="noreferrer"
            >
              here{" "}
            </a>
            to know more about growing issue of MEVs and how we aim to solve it!
          </p>

          <li className="faqTitle">Attributions</li>
          <p style={{ marginTop: "14px" }}>
            MEV.Tax was made possible with the power of open-source libraries
            <a
              href="https://docs.ethers.io/v5/"
              target="_blank"
              style={{ color: "#d77720" }}
              rel="noreferrer"
            >
              {" "}
              Ethers.js{" "}
            </a>
            and
            <a
              href="https://ant.design/"
              target="_blank"
              style={{ color: "#d77720" }}
              rel="noreferrer"
            >
              {" "}
              Ant Design{" "}
            </a>
            along with the free APIs provided by
            <a
              href="https://www.alchemy.com/"
              target="_blank"
              style={{ color: "#d77720" }}
              rel="noreferrer"
            >
              {" "}
              Alchemy{" "}
            </a>
            and
            <a
              href="https://www.coingecko.com/api/documentations/v3"
              target="_blank"
              style={{ color: "#d77720" }}
              rel="noreferrer"
            >
              {" "}
              CoinGecko
            </a>
            !
          </p>
        </ol>
      </div>
    );
    return (
      <div>
        <Layout style={{ minHeight: "68vh", marginBottom: "97px" }}>
          <Content style={{ textAlign: "center" }}>
            {this.renderTable()}
          </Content>
        </Layout>
        <Footer className="footer">
          <Collapse bordered={false} onChange={this.callback}>
            <Panel header="Questions & Answers" key="1">
              {content}
            </Panel>
          </Collapse>
          <Collapse bordered={false} onChange={this.callback}>
            <Panel header="Disclaimer" key="2">
              {disclaimer}
            </Panel>
          </Collapse>
        </Footer>
      </div>
    );
  }
}

export default App;
